<template>
  <UserLanding>
    <div class="cur_body">
      <div class="form">
        <h1>Welcome back!</h1>
        <div v-if="notification != null" class="notif">
          <span>
            <a-icon type="warning" style="color: red; font-size: 1.2rem" />You
            may have following problems bellow:
          </span>

          <span>{{ this.notification }}</span>
        </div>
        <div v-else class="hidden"></div>
        <a-form :form="loginForm">
          <a-form-item label="Email Address">
            <a-input type="email" size="large" v-decorator="[
              'email',
              {
                rules: [
                  {
                    required: true,
                    type: 'email',
                    message: 'Email is required',
                  },
                ],
              },
            ]" placeholder="Enter your email here" />
          </a-form-item>
          <a-form-item label="Password">
            <a-input type="password" size="large" v-decorator="[
              'password',
              {
                rules: [
                  {
                    required: true,
                    message: 'Password is required',
                  },
                ],
              },
            ]" placeholder="Enter your password here" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" html-type="submit" @click="login">Login</a-button>

          </a-form-item>
        </a-form>
        <router-link to="/find">Forgot Your Password?</router-link>
        <router-link to="/signUpNow">No Account, Need to Register One?</router-link>
        <router-link to="/adminlogin">Login As Admin</router-link>
      </div>
    </div>
  </UserLanding>
</template>
<style lang="less" scoped>
.cur_body {
  display: flex;
  height: 90vh;
  padding: 5vw 2vw;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  .form {
    display: flex;
    width: 55vw;
    height: 100%;
    margin-left: 2vw;
    padding-top: 2vw;
    flex-direction: column;
    justify-content: flex-start;
    align-items: space-between;

    h1 {
      font-size: 2.5rem;
      font-weight: bold;
    }

    .hidden {
      width: 30vw;
      height: 20vh;
    }

    .notif {
      display: flex;
      flex-direction: column;
      width: 30vw;
      height: 20vh;
      padding: 1vw;
      border: 1px solid red;

      .title {
        width: 100%;
        color: red;
        display: flex;
        flex-wrap: wrap;
      }

      span {
        color: red;
      }
    }

    a {
      color: #f1c331;
    }

    .form-body {
      margin-bottom: 5rem;
      width: 100%;

      .section {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: space-between;
        width: 100%;
        font-size: 1.1rem;
      }

      button {
        margin-top: 2vw;
        color: black;
        background: #f1c331;
        border: none;
        font-size: 1.2rem;
        font-weight: 700;
        padding: 1vw 2vw;

        &:hover {
          box-shadow: 4px 4px 12px #eee;
          background: linear-gradient(270deg, #efd584 0%, #f4ba01 92%);
        }
      }
    }
  }

  .rightcover {
    height: 50vh;
    object-fit: cover;
  }
}

@media screen and (max-width: 1120px) {
  .cur_body {
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-start;
    align-items: center;

    .form {
      width: 90%;
    }

    img {
      width: 100%;
      height: auto;
    }
  }
}
</style>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import UserLanding from "../../components/userlanding";
export default {
  components: {
    UserLanding,
  },
  computed: {
    ...mapGetters(["user/loading"]),
    ...mapState({
      error: (state) => state.user.error,
    }),
  },
  data() {
    return {
      email: "",
      password: "",
      loginForm: this.$form.createForm(this, { name: "login" }),
      notification: null,
    };
  },

  methods: {
    async login() {
      this.loginForm.validateFields(async (err, values) => {
        if (!err) {
          try {
            const res = await this.signIn({
              email: values.email,
              password: values.password,
            });
            if (res.role == "admin") {
              return this.$router.replace("/admin/elder");
            }
            if (res.role === "elder" || res.role == "volunteer") {
              return this.$router.replace("/user/home");
            }
          } catch (e) {
            return this.$notification.error({
              message: "Error happened",
              description: e.message,
            });
          }
        }
      });
    },
    ...mapActions({
      signIn: "user/login",
    }),
  },
};
</script>
